import pluralize from 'pluralize';
import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { type UseGallerySectionHeaderParams } from '~/components/Gallery/useGallerySectionHeader';
import { GalleryNestedSectionHeaderControls } from '~/components/v2/components/shared/gallery/GalleryNestedSectionHeaderControls';
import { GallerySectionHeader } from '~/components/v2/components/shared/gallery/GallerySectionHeader';

export const GALLERY_NESTED_SECTION_HEADER_HEIGHT = 32;

export type GalleryNestedSectionHeaderProps = Parameters<
  NonNullable<UseGallerySectionHeaderParams['renderHeader']>
>[0] & {
  /** Share links can lock nested content. Private boards omit this. */
  isDisabled?: boolean;
  /** See GalleryNestedSectionHeaderControls. Defaults to this gallery's first section. */
  isNestedChipHost?: boolean;
};

export const GalleryNestedSectionHeader = memo(
  ({
    collapsed,
    isDisabled = false,
    isFirstSection,
    isNestedChipHost = true,
    itemCount,
    label,
    onToggleCollapse,
    sectionType,
  }: GalleryNestedSectionHeaderProps) => {
    return (
      <div className={cn('flex items-center', !isFirstSection && 'pt-6')}>
        <GallerySectionHeader
          className="flex items-center"
          collapsed={collapsed}
          onToggleCollapse={onToggleCollapse}
          sectionLabel={label}
          style={{ height: GALLERY_NESTED_SECTION_HEADER_HEIGHT }}
        >
          {itemCount?.toLocaleString()} {pluralize(label, itemCount)}
        </GallerySectionHeader>
        <GalleryNestedSectionHeaderControls
          isDisabled={isDisabled}
          isFirstSection={isFirstSection}
          isNestedChipHost={isNestedChipHost}
          itemCount={itemCount ?? 0}
          sectionType={sectionType}
        />
      </div>
    );
  },
);

GalleryNestedSectionHeader.displayName = 'GalleryNestedSectionHeader';
